import styled from 'styled-components';
import { colors } from "nxtconstants";

export const CalculatorSection = styled.section`
    padding: 3rem 0rem;
    background-color: #f9f7ff;
    font-family: "Lato";

    @media (max-width: 768px) {
        margin: 0 auto 5.5rem;
    }
`;

export const ButtonContainer = styled.div`
    width: max-content;
    margin: 0 auto;
`;

export const ActionButton = styled.a`
    margin-top: 4rem;
    width: 23rem;
    height: 5.2rem;
    border-radius: 8rem;
    background-color: ${colors.primary};
    border: none;
    font-size: 1.8rem;
    font-weight: 700;
    font-family: 'Lato';
    text-align: center;
    color: ${colors.white};
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
        font-size: 1.8rem;
        padding: 1.6rem;
    }
`;

export const HeaderIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.2rem;
`;

export const IconBox = styled.div`
    width: 5rem;
    height: 5rem;
    border-radius: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 3.6rem;   
        height: 3.6rem;  
    }

    @media(max-width: 768px){ 
        img {
            width: 2rem;   
            height: 2rem;  
        }
    }
`;

export const HeaderLabel = styled.span`
    color: ${colors.pastelPurple};
    font-family: "Lato";
    font-weight: 500;
    font-size: 2rem;

    @media(max-width: 768px) {
        font-size: 1.8rem;
    }
`;

export const Heading = styled.h1`
    font-size: 4.2rem;
    font-family: "DM Serif Display";
    font-weight: 400;
    color: ${colors.textBlack};
    text-align: center;
    margin-bottom: 4rem;
    letter-spacing: -0.2px;

    @media (max-width: 768px) {
        font-size: 2.8rem;
        line-height: 1.2;
        padding: 0 1rem;
    }
`;

export const CalculatorWrapper = styled.div`
    display: grid;
    grid-template-columns: 40rem 1fr;
    gap: 6rem;
    width: 85%;
    max-width: 125rem;
    margin: 0 auto;
    align-items: start;
    background-color: white;
    border-radius: 2rem;
    padding: 4rem;

    @media (max-width: 850px) {
        grid-template-columns: 1fr;
        gap: 0;
        width: 85%; 
        padding: 0;
        background: transparent;
        border-radius: 0;
    }
`;

export const ControlPanel = styled.div`
    @media (max-width: 768px) {
        background-color: white;
        padding: 2.8rem;
        width: 100%;
        margin: 0 auto;
        border-top-left-radius: 2.8rem;
        border-top-right-radius: 2.8rem;
    }
`;

export const ToggleContainer = styled.div`
    display: inline-flex;
    margin-bottom: 4rem;
`;

export const ToggleButton = styled.button`
    padding: 1.2rem 2rem;
    font-family: "Lato";
    font-size: 2rem;
    font-weight: 400;
    border: none;
    cursor: pointer;
    background-color: ${props => props.active ? '#967DCC' : 'transparent'}; 
    color: ${props => props.active ? 'white' : '#6b7280'};
    border-radius: 10rem;
    transition: all 0.2s ease;
    margin-left: ${props => props.active ? '0' : '8px'};

    @media (max-width: 768px) {
        font-size: 1.6rem;
    }
`;

export const SliderContainer = styled.div`
    margin-bottom: 3.2rem;

    @media (max-width: 768px) {
        margin-bottom: 2.8rem;
    }
`;

export const SliderHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.2rem;

    @media (max-width: 768px) {
        gap: 1rem;
        flex-wrap: wrap;
    }
`;

export const SliderLabel = styled.label`
    font-size: 2rem;
    font-family: "Lato";
    font-weight: 400;
    color: ${colors.textBlack};

    @media (max-width: 768px) {
        font-size: 2rem;
        flex: 1;
        font-weight: 500;
        min-width: 0;
    }
`;

export const SliderValue = styled.div`
    background-color: ${colors.white};
    border: 1px solid #e5e7eb;
    border-radius: 1rem;
    padding: 8px 16px;
    font-size: 2.4rem;
    font-weight: 400;
    color: ${colors.textBlack};
    width: auto;
    gap: 0.5rem;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;

    @media (max-width: 768px) {
        font-size: 1.6rem;
        font-weight: 400;
        padding: 6px 12px;
        flex-shrink: 0;
    }
`;

export const StyledInput = styled.input`
    border: none;
    background: transparent;
    font-size: 2.4rem;
    font-weight: 400;
    color: ${colors.textBlack};
    width: auto;
    min-width: 5rem;
    text-align: right;
    padding: 0;
    outline: none;
    font-family: "Lato";

    @media(max-width: 768px) {
        font-size: 1.8rem;
        font-weight: 400;
        min-width: 4rem;
    }
`;

export const SliderWrapper = styled.div`
    position: relative;
    margin-bottom: 1rem;
`;

export const SliderTrack = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 4px;
    width: 100%;
    background-color: #e5e7eb;
    border-radius: 4px;
    pointer-events: none;
`;

export const SliderFill = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 4px;
    width: ${props => props.percentage}%;
    background-color: ${colors.pastelPurple};
    border-radius: 4px;

`;

export const SliderInput = styled.input`
    width: 100%;
    height: 2.4rem;
    background: transparent;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
    position: relative;
    z-index: 1;
    margin: 0;
    padding: 0;

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        background: white;
        border: 3px solid #8b5cf6;
        cursor: pointer;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }

    &::-moz-range-thumb {
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        background: white;
        border: 3px solid ${colors.pastelPurple}; ;
        cursor: pointer;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }

    &::-webkit-slider-thumb:hover {
        transform: scale(1.1);
        box-shadow: 0 2px 6px rgba(139, 92, 246, 0.3);
    }

    &::-moz-range-thumb:hover {
        transform: scale(1.1);
        box-shadow: 0 2px 6px rgba(139, 92, 246, 0.3);
    }
`;

export const SliderRange = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 1.2rem; 
    color: #9ca3af;
`;

export const ResultsPanel = styled.div`
    @media (max-width: 768px) {
        background-color: white;
        padding: 2.8rem;
        width: 100%;
        margin: 0 auto;
        border-bottom-left-radius: 2.8rem;
        border-bottom-right-radius: 2.8rem;
    }
`;

export const ResultsHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f9f7ff;
    padding: 2rem 2.8rem;
    border-radius: 1.2rem;
    margin-bottom: 3rem;

    @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;
    }
`;

export const ResultsLabel = styled.div`
    font-size: 2rem;
    font-family: "Lato";
    color: ${colors.eerieBlack};
    font-weight: 700;
    line-height: 1.4;

    @media (max-width: 768px) {
        font-size: 1.4rem;
        font-weight: 400;
        line-height: 1.3;
    }
`;

export const ResultsValues = styled.div`
    text-align: right;

    @media (max-width: 768px) {
        text-align: center;
    }
`;

export const TotalValue = styled.div`
    font-size: 3rem;
    font-family: "Lato";
    font-weight: 400;
    color: ${colors.textBlack};
    margin: 0;
    letter-spacing: -0.5px;

    @media(max-width: 768px) {
        font-size: 2.8rem;
        font-weight: 400;
    }
`;

export const InvestedAmount = styled.div`
    font-size: 1.6rem;
    font-family: "Lato";
    font-weight: 400;
    color: #6F6F6F;
    margin-top: 4px;

    @media (max-width: 768px) {
        font-size: 1.4rem;
    }
`;

export const ChartContainer = styled.div`
    width: 100%;
    overflow: hidden;

    @media (max-width: 768px) {
        margin: 0 -8px;
        overflow-x: auto;
        
        .recharts-wrapper {
            width: 100%;
        }
    }
`;

export const TooltipContainer = styled.div`
    background-color: white;
    border-radius: 1rem;
    padding: 1rem 1.2rem;
    box-shadow: none;
    font-size: 1.2rem;
`;

export const TooltipTitle = styled.p`
    font-weight: 600;
    margin-bottom: 6px;
`;

export const TooltipRow = styled.p`
    color: ${props => props.color};
    margin: 4px 0;
    display: flex;
    justify-content: space-between;
`;

export const TooltipValue = styled.span`
    font-weight: 600;
    margin-left: 1rem;
`;

export const CTASection = styled.div`
    text-align: center;
    color: #111827;
    margin-top: 3rem;
`;

export const CTAText = styled.div`
    font-size: 2.4rem;
    font-family: "Lato";
    font-weight: 400;
    margin-bottom: 1.6rem;

    @media (max-width: 768px) {
        display: none;
    }
`;

export const CTATextBold = styled.span`
    font-weight: 700;
`;
